import {AfterViewInit, Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {Board} from './board';
import {Subscription} from 'rxjs';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {Options} from '../options/options';
import {Snake} from '../snake/snake';
import {GameSize} from '../../verliba-shared';

@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.css']
})
export class BoardComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    private activatedRoute: ActivatedRoute,
    private gameSize: GameSize
    ) {}

  get width(): number {
    return this.gameSize.width;
  }

  get style(): any {
    const aspect = this.board ? this.board.rows / this.board.cols : 1;
    return {
      width: `${this.width}px`,
      height: `${this.width * aspect}px`,
    };
  }

  get snakeStyle(): any {
    return {
      top: `${this.bitSize}px`,
      left: `${this.bitSize}px`,
    };
  }

  get overlayStyle(): any {
    return Object.assign(this.style, {
      'font-size': `${this.bitSize * 4}px`
    });
  }

  get bitSize(): number {
    return this.width / (this.board.cols + 2);
  }

  @Input() options: Options;

  @Input() board: Board;

  private swipeCoord: [number, number];
  private swipeTime: number;
  private subscriptions: Subscription[];

  static diagonalToKeys(direction: number[], snake: Snake): [string, string] {
    const vec = snake.vector;
    const [dx, dy] = vec;
    const info = {
      l : ['b', 't', 'r', 1],
      r : ['b', 't', 'l', 1],
      t : ['r', 'l', 'b', 0],
      b : ['r', 'l', 't', 0]
    } [snake.direction];

    const dir2key = { l : 'ArrowLeft', r: 'ArrowRight', t: 'ArrowUp', b: 'ArrowDown'};
    const mult = [direction[0] * dx, direction[1] * dy];
    const first = dir2key[direction[info[3]] < 0 ? info[1] : info[0]];
    let second;
    if (!mult[0]) {
      // up or down
      second = dir2key[mult[1] > 0 ? snake.direction : info[2]];
    } else {
      second = dir2key[mult[0] > 0 ? snake.direction : info[2]];
    }
    return [first, second];
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.subscriptions = [this.activatedRoute.queryParamMap.subscribe((pars) => {
      this.parseQueryParams(pars);
    })];
  }

  @HostListener('document:keydown', ['$event'])
  onKey(ev: KeyboardEvent): boolean {
    return this.board.handleKey(ev.key);
  }

  swipe(e: TouchEvent, action: 'start'|'end'): boolean {
    console.log(`swipe ${action}`, e);
    const coord: [number, number] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const time = new Date().getTime();
    if (action === 'start') {
      this.swipeCoord = coord;
      this.swipeTime = time;
    } else {
      const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
      const duration = time - this.swipeTime;

      if (duration < 1500) {
        const dax = Math.abs(direction[0]);
        const day = Math.abs(direction[1]);
        const len = Math.sqrt(direction.reduce((r, v) => r + v * v, 0));
        if ( dax > this.bitSize && dax > day * 3)
        { // Horizontal enough
          const swipe = direction[0] < 0 ? 'ArrowLeft' : 'ArrowRight';
          this.board.handleKey(swipe);
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        if ( day > this.bitSize && day > dax * 3)
        { // Horizontal enough
          const swipe = direction[1] < 0 ? 'ArrowUp' : 'ArrowDown';
          this.board.handleKey(swipe);
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
        if (len < this.bitSize) {
          this.board.handleKey('ArrowUp');
          e.preventDefault();
          e.stopPropagation();
          return false;
        }

        if (len > this.bitSize && dax >= day * 0.7 && day >= dax * 0.7) {
          const [first, second] = BoardComponent.diagonalToKeys(direction, this.board.snakes[0]);
          this.board.handleKey(first);
          this.board.handleKey(second);
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    }
    return true;
  }

  private parseQueryParams(pars: ParamMap): void {
    if (pars.has('l')) {
      const l = Number.parseFloat(pars.get('l'));
      if (l >= 0 && l < 100) {
        this.board.startLevel = l;
        this.board.restart().catch();
      }
    }
  }
}
